import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-air-service-content',
    templateUrl: './air-service-content.component.html',
    styleUrls: ['./air-service-content.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AirServiceContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
